/** One storage pack: 100 GiB for $29 a month, added to the account's subscription (decided 2026-10-02) */
export const STORAGE_PACK_BYTES = 100 * 1024 ** 3;
export const STORAGE_PACK_PRICE_CENTS = 2900;
/** Finds the pack's Stripe Price in any Stripe account (created on first use) */
export const STORAGE_PACK_LOOKUP_KEY = "talon_storage_pack_100gib";

/**
 * An account's storage limit: its pricing tier's allowance plus its storage packs. A tier with no
 * allowance has no limit.
 */
export const getStorageLimitBytes = (
  tierAllowanceBytes: number | string | null | undefined,
  storagePacks = 0,
): number | null =>
  tierAllowanceBytes
    ? Number(tierAllowanceBytes) + storagePacks * STORAGE_PACK_BYTES
    : null;
